import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { SkinAnalyzerConfig } from '../models';

export const useSkinAnalyzerBrandData = (): SkinAnalyzerConfig[number] => {
  const {
    product: { brand },
  } = useProductDetailContext();

  const { pd_skin_analyzer_config } = useFeatureFlags();

  if (!brand) {
    return null;
  }

  return pd_skin_analyzer_config[brand.id];
};
